export default __webpack_public_path__ + "static/media/SpeengleMeengle.8bc771ea.png";